export default __webpack_public_path__ + "static/137-min-min-e702cbcb8beb87ed05d8d12a10a39658.jpg";